import { render, staticRenderFns } from "./workorder.vue?vue&type=template&id=377e49a7&"
import script from "./workorder.vue?vue&type=script&lang=ts&"
export * from "./workorder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports